// extracted by mini-css-extract-plugin
export default {"mainHeader":"Banner_mainHeader__M5S--","headerText":"Banner_headerText__4LCpN","passageLogo":"Banner_passageLogo__QZA+h","spacer":"Banner_spacer__Sw70e","link":"Banner_link__Oe6v3"};